// extracted by mini-css-extract-plugin
export default {"_404":"NotFound__404__yWLHf","btn":"NotFound_btn__2yjp1"};